import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { normalize_path } from '../vanilla-js/common';

/* Trigger vanillajs from React since DOM 'load' event is fired before React has loaded in IE11 */
export function useInitializeVanillaJs(): boolean {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const normalizedLocation = normalize_path(location.pathname);

      if (location.pathname !== normalizedLocation) {
        navigate(
          {
            ...location,
            pathname: normalizedLocation,
          },
          { replace: true },
        );
      } else {
        // Use globals here since not every page will load client.js and have these functions defined
        await window.initialize?.();
      }
      setLoading(false);
    })();
  }, [navigate, location]);
  return isLoading;
}
